import BarcodeScanFeature from "@/features/barcodeScan";

export default function BarcodeScanPage() {
  return (
    <div>
      <BarcodeScanFeature />
    </div>
  );
}
